import React, { useCallback, useState } from 'react';
import { swr, useAtomCallback, useAtomValue } from '@exodus/headless-ui';
import { feeAmountAtom, feeFiatAmountAtom, fromAssetAtom, preventFromExchangingAtom, quoteAtom, } from '../../../atoms/index.js';
const quoteSWRAtom = swr(quoteAtom);
const FeeDetails = ({ Component, className, onPress, style, initialFiatMode = false, }) => {
    const fee = useAtomValue(feeAmountAtom);
    const feeFiat = useAtomValue(feeFiatAmountAtom);
    const fromAsset = useAtomValue(fromAssetAtom);
    const preventFromExchanging = useAtomValue(preventFromExchangingAtom);
    const [fiatMode, setFiatMode] = useState(initialFiatMode);
    const handlePress = useAtomCallback((get) => {
        const quote = get(quoteSWRAtom);
        if (!quote.data)
            return;
        onPress?.({
            fee: get(feeAmountAtom),
            feeAsset: get(fromAssetAtom).feeAsset,
            swapStrategy: quote.data.swapStrategy,
            feeFiat: get(feeFiatAmountAtom),
        });
    }, [onPress]);
    const handleFiatModePress = useCallback(() => {
        setFiatMode((prev) => !prev);
    }, []);
    const valueToDisplay = fiatMode ? feeFiat : fee;
    if (!Component)
        return null;
    return (React.createElement(Component, { visible: !preventFromExchanging, value: valueToDisplay, fiatMode: fiatMode, feeAsset: fromAsset.feeAsset, className: className, style: style, onPress: handlePress, onFiatModePress: handleFiatModePress }));
};
export default FeeDetails;
